var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CCard',[_c('CCardBody',[_c('a',{attrs:{"href":_vm.item.url,"target":"_blank"}},[_c('img',{staticStyle:{"height":"100%","width":"100%","object-fit":"cover"},attrs:{"src":_vm.item.path}})])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }